if (!customElements.get('cart-remove-button')) {

  customElements.define('cart-remove-button', class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        cartItems.updateQuantity(this.dataset.index, 0);
      });
    }
  })
}

if (!customElements.get('cart-footer')) {
  customElements.define('cart-footer', class CartFooter extends HTMLElement {
    constructor() {
      super();   
      if(window.matchMedia("(min-width: 992px)").matches){
        this.cartType = this.dataset.type;    

        this.checkoutButton = document.querySelector(`#${this.cartType}-checkout`);

        window.onunload = () => {
            if(!this.checkoutButton) return;
            this.checkoutButton.querySelector('.loading-overlay-spinner').classList.add('hidden');
            this.checkoutButton.setAttribute('aria-disabled', false);
            this.checkoutButton.querySelector('span').style.color = "var(--color-text)"
        }

        if(this.checkoutButton){
          this.checkoutButton.addEventListener('click', (e) => {
            this.checkoutButton.querySelector('.loading-overlay-spinner').classList.remove('hidden');
            this.checkoutButton.setAttribute('aria-disabled', true);
            this.checkoutButton.querySelector('span').style.color = "transparent"
          })
        }
      }
    }
  })
}

if (!customElements.get('cart-items')) {
  customElements.define('cart-items', class CartItems extends HTMLElement {
    constructor() {
      super();
      
      this.cartType = this.dataset.type;
      this.lineItemStatusElement = document.querySelector(`#${this.cartType}-shopping-cart-line-item-status`);  

      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

      this.addEventListener('change', this.onChange);
    }

    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }

    updateQuantity(line, quantity, name) {
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      const lineItem =  document.querySelector(`#${this.cartType}-CartItem-${line}`);

      if (lineItem) {
       lineItem.querySelectorAll('button, .button-remove').forEach(btn => {
        btn.disabled = true;
        btn.style.opacity = 0.8;
       })
      } 

      fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          const cartFooter = document.querySelector(`#${this.cartType}-main-cart-footer`);       
          const cartPage = document.querySelector('.main-cart-page');
          const cartItems = document.querySelector(`#${this.cartType}-cart-items-inner`);
          const emptyPage = document.querySelector(`#${this.cartType}-cart-warnings`)
      
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartPage) cartPage.classList.toggle('main-cart', parsedState.item_count !== 0);
          if (emptyPage) emptyPage.classList.toggle('is-empty', parsedState.item_count !== 0);
          if (cartItems) cartItems.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));

          this.updateLiveRegions(line, parsedState.item_count);
          
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            lineItem.querySelector(`[name="${name}"]`).focus();
          } 
        
        }).catch((error) => {
          const errors = document.querySelector(`#${this.cartType}-cart-errors`);
          errors.textContent = window.cartStrings.error;
        })
    }

    updateLiveRegions(line, itemCount) {
      /* if (this.currentItemCount === itemCount) {
        const lineItemError = document.querySelector(`#${this.cartType}-Line-item-error-${line}`);
        const quantityElement = document.querySelector(`#${this.cartType}-Quantity-${line}`);

        lineItemError
          .querySelector('.cart-item-error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            quantityElement.value
          );       
      } */

      this.currentItemCount = itemCount;
      
      this.lineItemStatusElement.setAttribute('aria-hidden', true);

      const cartStatus = document.querySelector(`#${this.cartType}-cart-live-region-text`);
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }

    getSectionsToRender() {
      return [
        {
          id: `${this.cartType}-main-cart-items`,
          section: document.getElementById(`${this.cartType}-main-cart-items`).dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: `${this.cartType}-cart-live-region-text`,
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        },
        {
          id: `${this.cartType}-main-cart-footer`,
          section: document.getElementById(`${this.cartType}-main-cart-footer`).dataset.id,
          selector: '.cart-footer-checkout',
        }
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

  })
}

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();
      this.cartType = this.dataset.type;

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))

      //CART NOTE
      var cartNote = this.querySelector(`#${this.cartType}-cart-note`);

      if(cartNote && window.matchMedia("(min-width: 992px)").matches){
          this.querySelector(`#${this.cartType}-cart-details`).open = true;
      } 

      window.addEventListener("resize", () => {
          if(cartNote && window.matchMedia("(min-width: 992px)").matches){
              this.querySelector(`#${this.cartType}-cart-details`).open = true;
          }    
      });
    }
  });
};